(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var activeSlide = 0;
  var slideInterval = 6000; // Time in milliseconds for each slide
  var autoSlide;
  var singleVideoBanner = document.querySelector("[data-cp-home-banner-video]");
  var slider = document.querySelector(".slider");
  var sliderWrapper = slider ? slider.querySelector(".slider-wrapper") : null;
  var sliderItems = slider ? slider.querySelectorAll(".slider-item") : [];

  function forceMuted(video) {
    if (!video) return;
    // Ensure no autoplay audio on load (some browsers require JS-level muting).
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.setAttribute('muted', '');
  }

  function normalizeMediaUrl(src) {
    if (!src) return '';
    try {
      return new URL(src, window.location.href).href;
    } catch (e) {
      return src.indexOf('//') === 0 ? window.location.protocol + src : src;
    }
  }

  function updateMediaSourcesIn(root) {
    if (!root) return;

    root.querySelectorAll('.dynamicImage').forEach(function(img) {
      var mobileSrc = img.getAttribute('data-mobile-src');
      var desktopSrc = img.getAttribute('data-desktop-src');
      if (window.innerWidth <= 780 && mobileSrc) {
        img.src = mobileSrc;
      } else if (desktopSrc) {
        img.src = desktopSrc;
      }
    });

    root.querySelectorAll('video.slider-video').forEach(function(video) {
      forceMuted(video);
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      let mobileSrc = video.getAttribute('data-mobile');
      let desktopSrc = video.getAttribute('data-web');
      let selectedSrc = window.innerWidth <= 780 && mobileSrc ? mobileSrc : desktopSrc || mobileSrc;
      let currentSrc = video.currentSrc || video.getAttribute('src') || '';
      if (selectedSrc && normalizeMediaUrl(currentSrc) !== normalizeMediaUrl(selectedSrc)) {
        video.src = selectedSrc;
        video.load(); // Reload video with new source
      }
      // Re-apply mute after metadata loads (some browsers reset media state on src changes).
      video.addEventListener('loadedmetadata', function() { forceMuted(video); }, { once: true });
      if (selectedSrc) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function() {});
        }
      }
    });
  }

  if (singleVideoBanner) {
    updateMediaSourcesIn(singleVideoBanner);
    window.addEventListener('resize', function() {
      updateMediaSourcesIn(singleVideoBanner);
    });
  }

  if (!slider || !sliderWrapper) {
    return;
  }

  // Clone slides for infinite loop effect if more than one slide
  function cloneSlides() {
    if (sliderItems.length > 1) {
      sliderItems.forEach(item => {
        var clone = item.cloneNode(true);
        sliderWrapper.appendChild(clone);
      });
      sliderItems = slider.querySelectorAll(".slider-item"); // Update the NodeList
    }
  }

  function updateMediaSrc() {
    updateMediaSourcesIn(slider);
  }

  function createSlider() {
    if (sliderItems.length > 1) {
      cloneSlides(); // Clone slides for infinite effect
      startAutoSlide();
    }
    updateMediaSrc(); // Call to update media sources
    showSlide();
  }

  function showSlide() {
    if (!sliderWrapper) return;

    var slideWidth = sliderItems[0].offsetWidth;
    sliderWrapper.style.transition = 'transform 0.5s ease';
    sliderWrapper.style.transform = `translateX(-${slideWidth * activeSlide}px)`;

    sliderItems.forEach(item => item.classList.remove('active'));
    sliderItems[activeSlide].classList.add('active');
  }

  function nextSlide() {
    activeSlide++;
    if (activeSlide >= sliderItems.length) {
      activeSlide = 0;
      sliderWrapper.style.transition = 'none';
      sliderWrapper.style.transform = 'translateX(0)';
      setTimeout(() => {
        sliderWrapper.style.transition = 'transform 0.5s ease';
        activeSlide = 1;
        showSlide();
      }, 50);
    } else {
      showSlide();
    }
  }

  function startAutoSlide() {
    if (sliderItems.length > 1) {
      autoSlide = setInterval(nextSlide, slideInterval);
    }
  }

  createSlider();

  slider.addEventListener('mouseover', function() {
    clearInterval(autoSlide);
  });

  slider.addEventListener('mouseout', function() {
    startAutoSlide();
  });

  window.addEventListener('resize', function() {
    updateMediaSrc(); // Call to update sources on resize
    showSlide();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-video-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // Debounce function for resize events
  function debounce(func, wait) {
    var timeout;
    return function executedFunction() {
      var context = this;
      var args = arguments;
      var later = function() {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Countdown functionality with timezone support
  function initCountdown(countdownEl) {
    if (!countdownEl) return;

    var dateStr = countdownEl.getAttribute('data-date');
    var mode = countdownEl.getAttribute('data-mode') || 'global';
    
    if (!dateStr) return;

    var endDate;
    
    if (mode === 'local') {
      // LOCAL MODE: End at 23:59:59 in user's local timezone
      // Input format: YYYY-MM-DD (e.g., "2024-12-01")
      var dateParts = dateStr.split(/[-T]/);
      var year = parseInt(dateParts[0]);
      var month = parseInt(dateParts[1]) - 1;
      var day = parseInt(dateParts[2]);
      
      // Create date in user's local timezone at 23:59:59
      endDate = new Date(year, month, day, 23, 59, 59).getTime();
    } else {
      // GLOBAL MODE: Same end time for everyone (UTC)
      // Input format: YYYY-MM-DDTHH:MM:SSZ (e.g., "2024-12-01T18:29:00Z")
      if (dateStr.includes('T') && dateStr.includes('Z')) {
        endDate = new Date(dateStr).getTime();
      } else if (dateStr.includes('T')) {
        endDate = new Date(dateStr + 'Z').getTime();
      } else {
        // Legacy format: YYYY/MM/DD HH:MM:SS - treat as UTC
        var parts = dateStr.split(/[\s/:]+/);
        if (parts.length >= 6) {
          endDate = Date.UTC(
            parseInt(parts[0]), 
            parseInt(parts[1]) - 1, 
            parseInt(parts[2]),
            parseInt(parts[3]), 
            parseInt(parts[4]), 
            parseInt(parts[5])
          );
        } else {
          endDate = new Date(dateStr).getTime();
        }
      }
    }

    var daysEl = countdownEl.querySelector('[data-days]');
    var hoursEl = countdownEl.querySelector('[data-hours]');
    var minutesEl = countdownEl.querySelector('[data-minutes]');
    var secondsEl = countdownEl.querySelector('[data-seconds]');

    function updateCountdown() {
      var now = new Date().getTime();
      var distance = endDate - now;

      if (distance < 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    updateCountdown();
    var countdownInterval = setInterval(updateCountdown, 1000);

    return function cleanup() {
      clearInterval(countdownInterval);
    };
  }

  function initSlider(sliderEl) {
    var wrapper = sliderEl.querySelector('.slider-wrapper');
    if (!wrapper) return;

    var sliderItems = Array.from(wrapper.querySelectorAll('.slider-item'));
    if (sliderItems.length === 0) return;

    var dotsContainer = sliderEl.querySelector('.slider-dots');
    var prevBtn = sliderEl.querySelector('.slider-prev');
    var nextBtn = sliderEl.querySelector('.slider-next');
    var countdownEl = sliderEl.querySelector('[data-countdown]');

    // Initialize countdown if present
    var countdownCleanup = null;
    if (countdownEl) {
      countdownCleanup = initCountdown(countdownEl);
    }

    // Get settings from data attributes
    var settings = {
      autoplay: sliderEl.getAttribute('data-autoplay') === 'true',
      interval: parseInt(sliderEl.getAttribute('data-interval'), 10) || 6000,
      loop: sliderEl.getAttribute('data-loop') === 'true'
    };

    var currentIndex = 0;
    var autoplayInterval = null;
    var isTransitioning = false;
    var isMobile = window.innerWidth <= 768;

    // Determine if mobile or desktop
    function checkMobile() {
      isMobile = window.innerWidth <= 768;
    }

    // Load appropriate media for current slide
    function loadMedia(item) {
      if (!item) return;

      var video = item.querySelector('video.slider-video');
      var img = item.querySelector('img.slider-image');

      // Handle video
      if (video) {
        var videoSrc = isMobile 
          ? video.getAttribute('data-mobile-src') 
          : video.getAttribute('data-desktop-src');
        
        // Fallback to desktop if mobile not available
        if (!videoSrc && isMobile) {
          videoSrc = video.getAttribute('data-desktop-src');
        }

        if (videoSrc) {
          // Check if it's a valid video source
          if (videoSrc.match(/\.(mp4|webm|ogg)$/i) || videoSrc.indexOf('blob:') !== -1) {
            if (video.src !== videoSrc) {
              video.src = videoSrc;
            }
            video.load();
            
            // Try to play video
            var playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.then(function() {
                video.classList.add('active');
                if (img) img.style.visibility = 'hidden';
              }).catch(function(error) {
                // If video fails, show image
                console.log('Video play failed:', error);
                video.classList.remove('active');
                if (img) img.style.visibility = 'visible';
              });
            }
            return;
          }
        }
      }

      // Handle image (fallback or primary)
      if (img) {
        var imgSrc = isMobile 
          ? img.getAttribute('data-mobile-src') 
          : img.getAttribute('data-desktop-src');
        
        // Fallback to desktop if mobile not available
        if (!imgSrc && isMobile) {
          imgSrc = img.getAttribute('data-desktop-src');
        }

        if (imgSrc && img.src !== imgSrc) {
          img.src = imgSrc;
        }
        img.style.visibility = 'visible';
      }

      // Hide video if showing image
      if (video) {
        video.classList.remove('active');
        video.pause();
      }
    }

    // Stop media playback
    function stopMedia(item) {
      if (!item) return;
      
      var video = item.querySelector('video.slider-video');
      if (video) {
        video.pause();
        video.classList.remove('active');
      }
    }

    // Show slide at index
    function goToSlide(index, skipTransition) {
      if (isTransitioning || index < 0 || index >= sliderItems.length) return;
      
      isTransitioning = true;
      
      // Stop current slide media
      stopMedia(sliderItems[currentIndex]);

      currentIndex = index;

      // Calculate transform
      var slideWidth = sliderItems[0].offsetWidth;
      
      if (skipTransition) {
        wrapper.style.transition = 'none';
      } else {
        wrapper.style.transition = 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
      }
      
      wrapper.style.transform = 'translateX(-' + (slideWidth * currentIndex) + 'px)';

      // Update dots
      updateDots();

      // Load media for current slide
      loadMedia(sliderItems[currentIndex]);

      // Reset transition flag
      setTimeout(function() {
        isTransitioning = false;
      }, skipTransition ? 50 : 600);
    }

    // Update dot indicators
    function updateDots() {
      if (!dotsContainer) return;
      
      var dots = dotsContainer.querySelectorAll('.dot');
      dots.forEach(function(dot, idx) {
        if (idx === currentIndex) {
          dot.classList.add('active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.classList.remove('active');
          dot.setAttribute('aria-selected', 'false');
        }
      });
    }

    // Navigate to next slide
    function nextSlide() {
      var nextIndex = currentIndex + 1;
      
      if (nextIndex >= sliderItems.length) {
        if (settings.loop) {
          nextIndex = 0;
        } else {
          stopAutoplay();
          return;
        }
      }
      
      goToSlide(nextIndex);
    }

    // Navigate to previous slide
    function prevSlide() {
      var prevIndex = currentIndex - 1;
      
      if (prevIndex < 0) {
        if (settings.loop) {
          prevIndex = sliderItems.length - 1;
        } else {
          return;
        }
      }
      
      goToSlide(prevIndex);
    }

    // Start autoplay
    function startAutoplay() {
      if (!settings.autoplay || sliderItems.length <= 1) return;
      
      stopAutoplay();
      autoplayInterval = setInterval(nextSlide, settings.interval);
    }

    // Stop autoplay
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    // Setup dot click handlers
    if (dotsContainer) {
      var dots = dotsContainer.querySelectorAll('.dot');
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var index = parseInt(this.getAttribute('data-index'), 10);
          stopAutoplay();
          goToSlide(index);
          startAutoplay();
        });
      });
    }

    // Setup navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        stopAutoplay();
        prevSlide();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        stopAutoplay();
        nextSlide();
        startAutoplay();
      });
    }

    // Pause on hover
    sliderEl.addEventListener('mouseenter', stopAutoplay);
    sliderEl.addEventListener('mouseleave', startAutoplay);

    // Handle window resize
    var resizeHandler = debounce(function() {
      checkMobile();
      goToSlide(currentIndex, true);
      loadMedia(sliderItems[currentIndex]);
    }, 250);

    window.addEventListener('resize', resizeHandler);

    // Initialize
    checkMobile();
    goToSlide(0, true);
    startAutoplay();

    // Cleanup function
    return function cleanup() {
      stopAutoplay();
      if (countdownCleanup) countdownCleanup();
      window.removeEventListener('resize', resizeHandler);
    };
  }

  // Initialize all sliders on page
  function initAllSliders() {
    var sliders = document.querySelectorAll('.slider[data-section-id]');
    sliders.forEach(function(slider) {
      initSlider(slider);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  // Re-initialize on Shopify section events (theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var slider = event.target.querySelector('.slider[data-section-id]');
      if (slider) {
        initSlider(slider);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["img-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var activeSlide = 0;
  var slideInterval = 6000; // Time in milliseconds for each slide
  var autoSlide;
  var sliderWrapper = document.querySelector(".slider-wrapper");
  var sliderItems = document.querySelectorAll(".slider-item");
  var dots = document.getElementById('dots');

  if (!sliderWrapper) {
    console.error("Slider wrapper not found!");
    return;
  }

  function forceMuted(video) {
    if (!video) return;
    // Ensure no autoplay audio on load (some browsers require JS-level muting).
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.autoplay = true;
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  }

  function startMutedAutoplay(video) {
    if (!video) return;
    forceMuted(video);

    var playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(function() {
        // Autoplay can still be blocked by low-power/data-saver modes.
      });
    }
  }

  function syncVideoPlayback() {
    sliderItems.forEach(function(item, index) {
      var video = item.querySelector('video.slider-video');
      if (!video) return;

      if (index === activeSlide) {
        startMutedAutoplay(video);
      } else {
        video.pause();
      }
    });
  }

  // Clone slides for infinite loop effect if more than one slide
  function cloneSlides() {
    if (sliderItems.length > 1) {
      sliderItems.forEach(item => {
        var clone = item.cloneNode(true);
        sliderWrapper.appendChild(clone);
      });
      sliderItems = document.querySelectorAll(".slider-item"); // Update the NodeList
    }
  }

  function updateMediaSrc() {
    sliderItems.forEach(function(item) {
      let img = item.querySelector('.dynamicImage');
      let video = item.querySelector('video.slider-video');

      // Handle image source
      if (img) {
        var mobileSrc = img.getAttribute('data-mobile-src');
        var desktopSrc = img.getAttribute('data-desktop-src');
        if (window.innerWidth <= 780 && mobileSrc) {
          img.src = mobileSrc;
        } else if (desktopSrc) {
          img.src = desktopSrc;
        }
    }

      // Handle video source
      if (video) {
        forceMuted(video);
        let mobileSrc = video.getAttribute('data-mobile');
        let desktopSrc = video.getAttribute('data-web');
        video.src = window.innerWidth <= 780 ? mobileSrc : desktopSrc;
        video.load(); // Reload video with new source
        // Re-apply mute after metadata loads (some browsers reset media state on src changes).
        video.addEventListener('loadedmetadata', function() {
          forceMuted(video);
          if (item.classList.contains('active')) {
            startMutedAutoplay(video);
          }
        }, { once: true });
      }
    });
  }

  function createSlider() {
    if (sliderItems.length > 1) {
      cloneSlides(); // Clone slides for infinite effect
      sliderItems.forEach((item, index) => {
        var dot = document.createElement('li');
        dot.classList.add('list-inline-item');
        dot.setAttribute("data-index", index % (sliderItems.length / 2)); // Adjust index for dots
        dot.addEventListener("click", function() {
          clearInterval(autoSlide);
          activeSlide = Number(this.getAttribute("data-index"));
          showSlide();
          startAutoSlide();
        });
        if (index < sliderItems.length / 2) { // Only create dots for original slides
          dots.appendChild(dot);
        }
      });
      startAutoSlide();
    }
    updateMediaSrc(); // Call to update media sources
    showSlide();
  }

  function showSlide() {
    if (!sliderWrapper) return;

    var slideWidth = sliderItems[0].offsetWidth;
    sliderWrapper.style.transition = 'transform 0.5s ease';
    sliderWrapper.style.transform = `translateX(-${slideWidth * activeSlide}px)`;

    sliderItems.forEach(item => item.classList.remove('active'));
    sliderItems[activeSlide].classList.add('active');

    updateDots();
    syncVideoPlayback();
  }

  function updateDots() {
    var dotsChildren = dots.getElementsByTagName('li');
    Array.from(dotsChildren).forEach(dot => dot.classList.remove('active'));
    if (dotsChildren[activeSlide % (sliderItems.length / 2)]) {
      dotsChildren[activeSlide % (sliderItems.length / 2)].classList.add('active');
    }
  }

  function nextSlide() {
    activeSlide++;
    if (activeSlide >= sliderItems.length) {
      activeSlide = 0;
      sliderWrapper.style.transition = 'none';
      sliderWrapper.style.transform = 'translateX(0)';
      setTimeout(() => {
        sliderWrapper.style.transition = 'transform 0.5s ease';
        activeSlide = 1;
        showSlide();
      }, 50);
    } else {
      showSlide();
    }
  }

  function startAutoSlide() {
    if (sliderItems.length > 1) {
      autoSlide = setInterval(nextSlide, slideInterval);
    }
  }

  createSlider();

  document.querySelector('.slider').addEventListener('mouseover', function() {
    clearInterval(autoSlide);
  });

  document.querySelector('.slider').addEventListener('mouseout', function() {
    startAutoSlide();
  });

  window.addEventListener('resize', function() {
    updateMediaSrc(); // Call to update sources on resize
    showSlide();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  const shareButton = document.getElementById('share-button');
  const socialList = document.querySelector('.t4s-socials');
  const shareButtonContent = shareButton.querySelector('span');

  // Function to toggle the dropdown
  function toggleDropdown() {
      socialList.classList.toggle('show');
  }

  // Click event listener for the button
  shareButton.addEventListener('click', toggleDropdown);

  // Click event listener for the SVG icon inside the button
  shareButtonContent.addEventListener('click', (event) => {
      // Prevent the button from triggering the click event
      event.stopPropagation();
      toggleDropdown();
  });

  // Close the dropdown if the user clicks outside of it
  window.addEventListener('click', (event) => {
      if (!event.target.matches('#share-button') && !event.target.closest('.social-list')) {
          if (socialList.classList.contains('show')) {
              socialList.classList.remove('show');
          }
      }
  });

  } catch(e) { console.error(e); }
})();
})();
